if($('.social-buttons').length){
   // $('.custom-footer .contact-box').clone().addClass('soc').appendTo('.link-icons');
}

if($('footer#footer').length){
    $('footer#footer').before($('footer#footer .heurekaRating'))

    $('footer#footer .bannery_custom').insertAfter('.position--benefitHomepage')
    if($('.instagramFeed').length){
        $('footer#footer').before($('footer#footer .customInstagram'))
        $(".instagram-widget>a").each(function(){
            $(".instagramFeed").append('<div class="igfeed"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
        })
    }
    
}

if($('.custom-footer__newsletter').length){
    $('.custom-footer__newsletter').wrapInner('<div class="container"><div class="inner"></div></div>')
    $('.custom-footer__newsletter .inner').before($('footer#footer .contact-box'))
}